/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    active: {
      description: 'Used to mark currently active Item or and ItemGroup containing the currently active Item',
      type: 'state',
      values: [ true, false ]
    },
    expanded: {
      description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
      type: 'state',
      values: [ true, false ]
    },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    type: {
      description: '`parent` being the toggle button for an ItemsGroup, and `child` an element of the ItemGroup',
      type: 'state',
      values: [ 'child', 'parent' ]
    }
  },
  rules: [
    {
      if: { active: true },
      tokens: {
        accentBackgroundColor: '#4b286d',
        backgroundColor: '#f4f4f7',
        color: '#4b286d',
        fontName: 'HNforTELUSSA',
        fontWeight: '700',
        paddingLeft: 12
      }
    },
    {
      if: { type: 'child' },
      tokens: {
        accentBackgroundColor: '#f4f4f7',
        accentOffset: 16,
        borderWidth: 0,
        fontSize: 14,
        lineHeight: 1.45,
        paddingLeft: 36
      }
    },
    {
      if: { active: true, type: 'parent' },
      tokens: { color: '#4b286d', paddingLeft: 12 }
    },
    {
      if: { active: true, expanded: true, type: 'parent' },
      tokens: {
        accentBackgroundColor: 'rgba(0, 0, 0, 0)',
        color: '#4b286d',
        fontName: 'HNforTELUSSA',
        fontWeight: '400',
        paddingLeft: 16
      }
    },
    {
      if: { hover: true },
      tokens: { backgroundColor: '#f4f4f7', color: '#4b286d' }
    },
    {
      if: { focus: true },
      tokens: { backgroundColor: '#f4f4f7', color: '#4b286d' }
    },
    {
      if: { active: true, type: 'child' },
      tokens: {
        accentBackgroundColor: '#4b286d',
        accentPadding: 16,
        backgroundColor: '#f4f4f7'
      }
    },
    {
      if: { active: false, hover: true, type: 'child' },
      tokens: {
        accentBackgroundColor: '#ffffff',
        accentOffset: 0,
        accentWidth: 16,
        color: '#414547'
      }
    }
  ],
  tokens: {
    accentBackgroundColor: 'rgba(0, 0, 0, 0)',
    accentOffset: 0,
    accentPadding: 0,
    accentWidth: 4,
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderColor: '#b2b9bf',
    borderStyle: 'solid',
    borderWidth: 1,
    color: '#414547',
    fontName: 'HNforTELUSSA',
    fontSize: 16,
    fontWeight: '400',
    justifyContent: 'space-between',
    lineHeight: 1.5,
    paddingBottom: 16,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 16
  }
}
export default theme
